document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.pc-home');
  if (!root) return;

  var main = root.querySelector('.pc-main-image img');
  if (!main) return;

  var packImages = {
    '57523461357908': 'https://cdn.shopify.com/s/files/1/1082/7294/3444/files/ccd09cbf-ec37-4f61-af5f-92cf5d0c4a47.png?v=1791624265',
    '57523461390676': 'https://cdn.shopify.com/s/files/1/1082/7294/3444/files/4f65d0b8-e3df-4b17-8da6-0296b6ad660b.png?v=1791624255',
    '57523461423444': 'https://cdn.shopify.com/s/files/1/1082/7294/3444/files/6361006b-1ad0-4db1-a042-568d495e3746.png?v=1791624255',
    '57523461456212': 'https://cdn.shopify.com/s/files/1/1082/7294/3444/files/a963365e-dbfe-4195-b194-b2e94f80dca3.png?v=1791624255',
    '57523461488980': 'https://cdn.shopify.com/s/files/1/1082/7294/3444/files/ef387835-d591-4ae3-904b-9701c4f43308.png?v=1791624254'
  };

  function variantNumber(value) {
    var match = String(value || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function showPackImage(radio) {
    if (!radio) return;
    var id = variantNumber(radio.value);
    var src = packImages[id];
    if (!src) return;

    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src = src;

    var label = radio.closest('.pc-pack');
    var title = label ? label.querySelector('.pc-pack-title') : null;
    if (title) main.alt = 'PetClean ' + title.textContent.trim();

    root.querySelectorAll('.pc-thumb').forEach(function (thumb) {
      var thumbSrc = String(thumb.dataset.src || '').split('?')[0];
      var imageSrc = String(src).split('?')[0];
      thumb.classList.toggle('is-active', thumbSrc === imageSrc);
    });
  }

  root.querySelectorAll('.pc-pack input[name="id"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      showPackImage(radio);
    });
  });

  var checked = root.querySelector('.pc-pack input[name="id"]:checked');
  if (checked) showPackImage(checked);
});
